module.exports = __webpack_public_path__ + "img/loginTitle.8258cff1.png";